import React from 'react';
import { CheckIcon } from 'lucide-react';
const useCases = ['Customer support automation reducing ticket volume by 60%+', 'Sales lead qualification and intelligent routing', 'Document processing and data extraction', 'Predictive maintenance for equipment and systems', 'Inventory optimization and demand forecasting', 'Personalized product recommendations', 'Automated content generation and summarization', 'Sentiment analysis for customer feedback', 'Fraud detection and anomaly identification', 'Process optimization through pattern recognition'];
export function AIUseCases() {
  return <section className="py-20 bg-surface" data-id="element-222">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-223">
        <div className="scroll-fade-in-up" data-id="element-224">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-8 text-center" data-id="element-225">
            Practical AI Applications
          </h2>
          <div className="bg-white rounded-xl p-8 md:p-12" data-id="element-226">
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-227">
              {useCases.map((useCase, i) => <li key={i} className="flex items-start" data-id="element-228">
                  <CheckIcon className="w-6 h-6 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-229" />
                  <span className="text-gray-700" data-id="element-230">{useCase}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}